import IQuickMessage from '@shared/models/quick-message/quick-message.model';


export default interface Conversation {
  id: string;
  type: number;
  channel: number;
  fanpageId: string;
  fanpageUserId: string;
  fanpageUserName: string;
  fanpagePostId?: string;
  commentId?: string;
  link?: string;
  lastMessage?: string;
  lastMessageId?: string;
  lastSentMessageTime?: number;
  lastSeenMessageTime?: number;
  status?: number;
  hasPhone?: boolean;
  hasReply?: boolean;
  tagIds?: Array<any>;
  logViews?: any;
  updatedTime?: number;
  createdTime?: number;
  fromAdsId?: string;
  customerAvatar?: string;
  threadId?: any;
  threadKey?: string;
  fbUserId?: any;
  // Extend for display
  fblink?: string;
  assigneeIds?: string[];
  assignedGroupId?: string;
  topics?: any;
  is_typing?: any;
  adIds?: string[];
  isPartnerReply?: boolean;
  postIds?: any;
  countUnread?: number
}

export interface IChannelCapabilities {
  canSendImage: boolean;
  canSendFile: boolean;
  canSendSticker: boolean;
  canPrivateReply: boolean;
}


export interface InputInterface {
  txt: string;
  ats: Array<any>;
  childs?: Array<any>;// Chứa các tin nhắn con của tin nhắn nhanh, nếu có.
  clipboard?: {
    isClipboard: boolean,
    files: any[],
    url_2?: string
  };// Chứa dữ liệu ảnh được copy vào clipboard
  file?: any;// Chứa dữ liệu file đính kèm như docx,xlsx...
  endTyping?: any;
  delayTyping?: boolean;
  nEnterNoReply?: number;// Kiểm tra số lần nhấn enter khi ô input trống
  nextID?: any;// ID hội thoại tiếp theo, nhấn enter 2 lần sẽ chuyển qua.
  requireAddress?: any;// yêu cầu địa chỉ
  messageReply?: any; // Chứa nội dung tin nhắn đang được trả lời
  sendPriority?: number; // Ưu tiên gửi ảnh trước, chữ trước
  templates?: [], // gửi kèm template
  formId?: string, // gửi kèm form đính trong template
}

export interface QuickmsgInterface {
  show: boolean;
  index: number;
  items?: IQuickMessage[];// Danh sách message đã lọc.
  originItems?: any[];// Chứa danh sách tin nhắn nhanh chưa filter.
  processedItems?: any[];// Chứa danh sách tin nhắn nhanh theo pageId
  pageIdSelected?: any;// pageId
  filter: 'shortcut' | 'message';// Loại filter sẽ dùng.
  txt?: string;
}

export const TYPE_CONVERSATION = {
  COMMENT: 1,
  INBOX: 2,
  GROUP: 3,
  CHANNEL: 4
};
export const STATUS_READ = {
  UNREAD: 1,
  READED: 2
};
export const CHANNEL = {
  FACEBOOK: 1,
  INSTAGRAM: 2,
  SHOPEE: 4,
  ZALO: 5,
  LAZADA: 6,
  TELEGRAM: 7,
  WHATSAPP: 8,
  TIKTOK: 9,
  ZALO_PERSONAL: 10,
  TIKTOK_BUSINESS: 11,
  /** Threads là kênh bình luận công khai, không phải inbox/DM. */
  THREADS: 12,
};

/**
 * Nguồn hiển thị chung cho mọi channel.
 * Các màn hình chỉ tham chiếu registry này thay vì tự khai báo lại name/icon,
 * để tránh lệch như "TikTok" và "TikTok Shop" giữa màn kết nối và bộ lọc.
 */
export interface IChannelPresentation {
  id: number;
  name: string;
  /** Phosphor icon không kèm prefix `ph`/`ph-fill`. */
  icon: string;
  /** Đường dẫn dùng với `imgCdn`. */
  logo: string;
}

export const CHANNEL_PRESENTATIONS: readonly IChannelPresentation[] = [
  {id: CHANNEL.FACEBOOK, name: 'Facebook', icon: 'facebook-logo', logo: 'logo/facebook.svg'},
  {id: CHANNEL.INSTAGRAM, name: 'Instagram', icon: 'instagram-logo', logo: 'logo/instagram.svg'},
  {id: CHANNEL.SHOPEE, name: 'Shopee', icon: 'storefront', logo: 'logo/shopee_logo.png'},
  {id: CHANNEL.ZALO, name: 'Zalo OA', icon: 'chat-circle', logo: 'logo/zoa.svg'},
  {id: CHANNEL.LAZADA, name: 'Lazada', icon: 'shopping-bag', logo: 'logo/lazada.svg'},
  {id: CHANNEL.TELEGRAM, name: 'Telegram', icon: 'telegram-logo', logo: 'logo/telegram_logo.svg'},
  {id: CHANNEL.WHATSAPP, name: 'WhatsApp', icon: 'whatsapp-logo', logo: 'logo/whatsapp.png'},
  {id: CHANNEL.TIKTOK, name: 'TikTok Shop', icon: 'tiktok-logo', logo: 'logo/tiktok_shop.svg'},
  {id: CHANNEL.ZALO_PERSONAL, name: 'Zalo cá nhân', icon: 'chats-circle', logo: 'logo/zalo_logo.png'},
  {id: CHANNEL.TIKTOK_BUSINESS, name: 'TikTok', icon: 'tiktok-logo', logo: 'logo/tiktok.svg'},
  {id: CHANNEL.THREADS, name: 'Threads', icon: 'threads-logo', logo: 'logo/threads.svg'},
];

export const CHANNEL_NAME: Record<number, string> = Object.fromEntries(
  CHANNEL_PRESENTATIONS.map(channel => [channel.id, channel.name]),
);

export function getChannelPresentation(channel: number | string | null | undefined): IChannelPresentation | undefined {
  return CHANNEL_PRESENTATIONS.find(item => item.id === Number(channel));
}

export function getChannelName(channel: number | string | null | undefined, fallback = ''): string {
  return getChannelPresentation(channel)?.name ?? fallback;
}

export function getChannelLogo(channel: number | string | null | undefined): string {
  return getChannelPresentation(channel)?.logo ?? '';
}

export const MSG_STATUS = {
  SENT: 1,
  ERROR: 2,
  SENDING: 3
};

export const MSG_TYPE = {
  TEXT: 1,
  PRODUCT: 2,
  VOUCHER: 3,
  ORDER: 4,
  ADDRESS: 5,
  FEEDBACK: 6,
  TEMPLATE: 7,
  STICKER: 8,
  QUICK_REPLIES: 9,
};

export const ACTIVITY_TYPE = {
  ACTIVITY_TYPE_VIEW: 1,
  ACTIVITY_TYPE_TAG_ADD: 2,
  ACTIVITY_TYPE_TAG_DEL: 3
};


/** System assignee IDs reserved for conversation distribution and visibility. */
export const ASSIGNEE_ID_STOP_SPLIT = 'stop_split';
export const ASSIGNEE_ID_ALL_STAFF_VIEW = 'all_staff_view';
export const SYSTEM_ASSIGNEE_IDS: readonly string[] = [
  ASSIGNEE_ID_STOP_SPLIT,
  ASSIGNEE_ID_ALL_STAFF_VIEW,
] as const;

export const MsgOrderInformation = [
  "phone",
  "name",
  "address_line_1",
  "administrative_area",
  "subadministrative_area",
  "locality",
  "country",
  'shipping_notes',
  'postal_code'
];
// số ngày giới hạn cho phép lọc chia lại
export const LIMIT_DAY_RE_SPLIT = 7

export const CODE_RETURN_SPLIT = {
  INVALID_CONVERSATION: -1, // hội thoại không hợp lệ
  INVALID_PAGE: -2, // page không hợp lệ
  INVALID_BUSINESS: -3, // doanh nghiệp không hợp lệ
  INVALID_SETTING: -4, // chưa được setting
  INVALID_LIMIT_TIME: -5, // giới hạn thời gian chia hoạt động
  INVALID_IGNORE_LIVE: -6, // bỏ qua bài live
  INVALID_IGNORE_POSTS: -7, // bỏ qua bài posts
  INVALID_SETTING_MODE: -8, // chưa chọn chế độ chia
  INVALID_SETTING_PAGE: -9, // page không thuộc danh sách áp dụng chia
  IGNORE_NEW_SPLIT: -10, // bỏ qua, ko check chia mới
  NO_STAFF: -11, // ko có nv nào hợp lệ
  INVALID_IGNORE_MANUAL: -12, // chia thủ công
  SPLIT_SUCCESS: 1, // chia thành công
};

export const CODE_RETURN_SPLIT_NAME = {
  [CODE_RETURN_SPLIT.INVALID_CONVERSATION]: 'Hội thoại không hợp lệ',
  [CODE_RETURN_SPLIT.INVALID_PAGE]: 'Page không hợp lệ',
  [CODE_RETURN_SPLIT.INVALID_BUSINESS]: 'Page chưa được gắn vào doanh nghiệp',
  [CODE_RETURN_SPLIT.INVALID_SETTING]: 'Chưa setting',
  [CODE_RETURN_SPLIT.INVALID_LIMIT_TIME]: 'Giới hạn thời gian chia hoạt động',
  [CODE_RETURN_SPLIT.INVALID_IGNORE_LIVE]: 'Bỏ qua bài live',
  [CODE_RETURN_SPLIT.INVALID_IGNORE_POSTS]: 'Bỏ qua bài posts',
  [CODE_RETURN_SPLIT.INVALID_SETTING_MODE]: 'Chưa chọn chế độ chia',
  [CODE_RETURN_SPLIT.INVALID_SETTING_PAGE]: 'Page không thuộc danh sách áp dụng chia',
  [CODE_RETURN_SPLIT.IGNORE_NEW_SPLIT]: 'Bỏ qua, không check chia mới',
  [CODE_RETURN_SPLIT.NO_STAFF]: 'Không tìm thấy nhân viên nào',
  [CODE_RETURN_SPLIT.INVALID_IGNORE_MANUAL]: 'Bỏ qua đang áp dụng chia thủ công',
  [CODE_RETURN_SPLIT.SPLIT_SUCCESS]: 'Chia thành công',
};


export const typeAllowPreview = [
  'application/msword', // doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
  'application/vnd.ms-excel', // xls
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
  'application/vnd.ms-powerpoint', // ppt
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', // pptx
  'application/json',
  'application/pdf',
  'text/plain',
  'txt',
  'ppt',
  'pptx',
  'xlsx',
  'xls',
  'docx',
  'doc',
  'json',
  'pdf',
]

// loại ảnh và file đc upload ở ghi chú
export const imageTypeAllow = ['image/gif', 'image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/avif', 'webp', 'jpeg', 'jpg', 'png', 'gif']
export const fileTypeAllow = ['application/x-compressed', 'application/x-zip-compressed', 'application/x-tar']
